import Vue from 'vue';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import PortalVue from 'portal-vue';
import VueI18n from 'vue-i18n';
import VueLuxon from 'vue-luxon';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueLogger from 'vuejs-logger';
import VuePhoneNumberInput from 'vue-phone-number-input';
import movable from 'v-movable';
import RichNumberInput from './components/RichNumberInput.vue';
import SearchBar from './components/SearchBar.vue';
import TheApplication from '../plugins/TheApplication';
import App from './App.vue';
import router from './router';
import store from './store';
import './assets/app.scss';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

Vue.component('VuePhoneNumberInput', VuePhoneNumberInput);
Vue.component('RichNumberInput', RichNumberInput);
Vue.component('SearchBar', SearchBar);

const ProjectToolsComponentContext = require.context('./components/Project/Tool', true, /\.vue$/i, 'lazy');
for (const componentFilePath of ProjectToolsComponentContext.keys()) {
	const componentName = componentFilePath.split('/').pop().split('.')[0];
	Vue.component(componentName, () => ProjectToolsComponentContext(componentFilePath));
}

/* const EntityEditorComponentContext = require.context('./components/Project/DatasetHandler', true, /\.vue$/i, 'lazy');
for (const componentFilePath of EntityEditorComponentContext.keys()) {
	const componentName = componentFilePath.split('/').pop().split('.')[0];
	Vue.component(componentName, () => EntityEditorComponentContext(componentFilePath));
} */

// specify global filters
Vue.filter('capitalize', (value) => {
	if (!value) return '';
	value = value.toString();
	return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(movable);
Vue.use(PortalVue);
Vue.use(VueLuxon);
Vue.use(VueI18n);
Vue.config.productionTip = false;
Vue.use(VueAxios, axios);
Vue.use(TheApplication, { viewer: 'CesiumViewer' });

const isProduction = process.env.NODE_ENV === 'production';

const options = {
	isEnabled: true,
	logLevel: isProduction ? 'error' : 'debug',
	stringifyArguments: false,
	showLogLevel: true,
	showMethodName: true,
	separator: '|',
	showConsoleColors: true,
};

Vue.use(VueLogger, options);

// used to generate fake form data for testing
Vue.use(require('vue-faker'));

const en = require('./lang/en.json');

const i18n = new VueI18n({
	locale: 'en',
	messages: {
		en,
	},
});

new Vue({
	i18n,
	router,
	store,
	render: (h) => h(App),
}).$mount('#app');
